import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModuleType } from '@fi-shared/types/module-type';
import { PostModel } from '@fi-shared/models';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { Subject } from 'rxjs';
import { AccessRightFiltersComponent } from '@fi-shared/access-right-filters';
import { AccessRightFilterSettings } from '@fi-shared/access-right-filters';
import { ContenteditableModelDirective } from '@fi-shared/contenteditable-model/contenteditable-model.directive';
import { FiMobileAppHelperService } from '@fi-app/utilities/fi-services/mobile-app-helper.service';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { takeUntil } from 'rxjs/operators';
import { ObjectTypes } from '@fi-shared/types';

export interface INewsFeedEditMobileDialogData {
    post: PostModel;
    moduleType: ModuleType;
    searchObjectId?: number;
}
export enum FiPostEditScreen {
    EditPostText = 0,
    SharingSelection = 1,
}
@Component({
    selector: 'fi-news-feed-edit-mobile-dialog',
    templateUrl: './edit-mobile-dialog.component.html',
    styleUrls: ['./edit-mobile-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-news-feed-edit-mobile-dialog' },
    standalone: false,
})
export class NewsFeedEditMobileDialogComponent implements OnDestroy {
    @ViewChild('editor', { static: true }) editorRef: ElementRef;
    @ViewChild('accessRightFilters', { static: false }) accessRightFilters: AccessRightFiltersComponent;
    @ViewChild('fiContenteditableModel', { static: false }) fiContenteditableModel: ContenteditableModelDirective;

    screen: number = FiPostEditScreen.EditPostText;
    AccessRightFilterSettings: AccessRightFilterSettings;
    fiLinkToType = FiLinkToType;
    fiPostEditScreen = FiPostEditScreen;

    ObjectTypes = ObjectTypes;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: INewsFeedEditMobileDialogData,
        private matDialogRef: MatDialogRef<NewsFeedEditMobileDialogComponent>,
        private cd: ChangeDetectorRef,
        private elementRef: ElementRef,
        private matDialog: MatDialog,
        private loadingService: LoadingService,
        private fiMobileAppHelperService: FiMobileAppHelperService,
        private sessionService: SessionService,
        private userDataService: FiUserDataService,
    ) {
        this.AccessRightFilterSettings = new AccessRightFilterSettings(
            this.data.moduleType,
            true,
            false,
            this.getObjectType(),
        );
        //this.AccessRightFilterSettings.SelectionMode = AccessRightTabs.QuickChoice;
        this.matDialog.afterOpened.pipe(takeUntil(this.ngOnDestroy$)).subscribe(() => {
            this.fiMobileAppHelperService.showKeyboard();
        });
    }

    closeClick() {
        this.matDialogRef.close(false);
    }

    setCurrentScreen(newScreen: FiPostEditScreen) {
        this.screen = newScreen;
    }

    isNextDisabled() {
        return !this.data.post.Content && !this.data.post.MediaBankFileReferences.length;
    }

    savePost() {
        if (this.isForumPost()) {
            this.matDialogRef.close(true);
        } else {
            this.accessRightFilters.OnAccessRightFilterCollectionSaving();
            const isAccessRightFilterCollectionValid = this.accessRightFilters.validateAccessRightFilterCollection();
            if (isAccessRightFilterCollectionValid) {
                this.accessRightFilters.OnAccessRightFilterCollectionSaved();
                this.matDialogRef.close(true);
            }
        }
    }

    getObjectType() {
        return this.isForumPost() ? ObjectTypes.ForumPost : ObjectTypes.Post;
    }

    isForumPost() {
        return this.data.moduleType === ModuleType.ForumPost;
    }

    getUserProfile() {
        return this.userDataService.getUserProfile();
    }

    /*
    triggerChangeEvent() {
        this.editorRef.nativeElement.dispatchEvent(new Event("change"));
        this.editorRef.nativeElement.focus();
    }
*/

    isSharingSelectionScreen(): boolean {
        return this.screen === FiPostEditScreen.SharingSelection;
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
